module.exports = __webpack_public_path__ + "img/ban_15.f1a9660f.png";